const getValue = (options, value) => {
  return options?.find((option) => option?.value === value)?.label || value;
};

export default getValue;
